import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import FooterCustomized from "../../../../modules/home/components/FooterCustomized";
import { PUBLIC_MODE } from "../../../constants/generalConstants";
import { useTSData } from "../../general/TSDataContext";
import TSGrid from "../TSGrid";
import NavBarDynamic from "./NavBarDynamic";

const NavBar = ({ children }) => {
  const { mode: modeApp, isMobile, isMidium } = useTSData();
  const theme = useTheme();
  const routes = [
    /*{
      label: "A propos",
      name: "A_PROPOS",
      path: "/a-propos",
      disabled: true,
      mode: [MODE_NON_CONNECTE, MODE_CONNECTE],
    },
    {
      label: "Outils et ressources",
      name: "OUTILS_ET_RESSOURCES",
      mode: [MODE_NON_CONNECTE, MODE_CONNECTE],
      children: [
        {
          label: "Outils",
          name: "OUTILS",
          path: "/outils",
          disabled: true,
          mode: [MODE_NON_CONNECTE, MODE_CONNECTE],
        },
        {
          label: "Ressources",
          path: "/ressources",
          disabled: true,
          mode: [MODE_NON_CONNECTE, MODE_CONNECTE],
        },
      ],
    },
    {
      label: "Connexion",
      name: "CONNEXION",
      dialog: "CONNEXION__DIALOG",
      mode: [MODE_NON_CONNECTE],
    },
    {
      label: "Mon profil",
      name: "MON_PROFIL",
      path: "/mon-profil",
      disabled: true,
      mode: [MODE_CONNECTE],
    },*/
  ];

  return (
    <Box
      sx={{
        ...(modeApp === PUBLIC_MODE &&
          theme?.mode !== "light" && {
            background:
              "url('/assets/backgroundHome01.jpeg') no-repeat center center fixed",
            backgroundSize: "cover",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
          }),
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <TSGrid
        container
        sx={{
          ...(modeApp === PUBLIC_MODE &&
            theme?.mode !== "light" && {
              backgroundSize: "cover",
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.6)",
            }),
          flexGrow: 1,
        }}
      >
        <TSGrid
          item
          xs={12}
          sx={{ paddingBottom: "15px", height: "fit-content" }}
        >
          <NavBarDynamic
            routes={routes}
            modeBg={theme?.mode}
            isMobile={isMobile}
            isMidium={isMidium}
          />
        </TSGrid>
        <TSGrid
          item
          xs={12}
          sx={{
            justifyContent: "center",
            alignItems: "center",
            flexGrow: 1,
          }}
        >
          {children}
        </TSGrid>
        <TSGrid item xs={12} sx={{ marginTop: "auto", textAlign: "center" }}>
          <FooterCustomized />
        </TSGrid>
      </TSGrid>
    </Box>
  );
};

export default NavBar;
